// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__26RvW","label":"Radio_label__MO49l","checkMark":"Radio_checkMark__2ZBfK","disabled":"Radio_disabled__1olXb"};